import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Select } from 'antd';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import NotificationContext from '@totem/components/utilities/notification/NotificationContext';
import { LoginProfile } from '@totem/types/user';
import { LOGIN_PROFILE_ENDPOINT } from '@totem/utilities/endpoints';
import logger from '@totem/utilities/logger';
import {
  consumePostLoginRedirect,
  setPostLoginRedirect,
} from '@totem/utilities/loginRedirect';
import { hasMongoObjectId } from '@totem/utilities/navigation';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

import './organizationSwitcherDropdown.css';

const { Option } = Select;

const OrganizationSwitcherDropdown = () => {
  const [loadingToken, setLoadingToken] = useState<boolean>(false);
  const navigate = useNavigate();
  const { notify } = useContext(NotificationContext);
  const location = useLocation();

  const { userProfile, loading, setProfileAndToken, setTokenTTL, getApiToken } =
    useContext(UserProfileContext);
  const { organizations, organization } = userProfile;

  const sendOrganizationSwitch = (
    userId: string,
    newOrganizationId: string,
  ) => {
    try {
      if (!loadingToken) {
        setLoadingToken(true);

        fetch(
          `${LOGIN_PROFILE_ENDPOINT}/${userId}/${newOrganizationId}/switch`,
          {
            method: 'GET',
            headers: new Headers({
              Authorization: `Bearer ${getApiToken()}`,
            }),
          },
        )
          .then((res) => {
            if (res.status >= 400) {
              logger.error(res.statusText);
            }
            return res.json();
          })
          .then((result: LoginProfile) => {
            if (result.ttlMinutes > 0) {
              setTokenTTL(result.ttlMinutes);
            }
            setProfileAndToken(
              result.profile,
              result.token,
              'OrganizationSwitcherDropdown',
            );
            //navigate('/');
            const redirectPath = consumePostLoginRedirect();
            navigate(redirectPath || '/');
          })
          .then(() => {
            setLoadingToken(false);
          });
      }
    } catch {
      notify(`Could not switch to the organization`, true);
    }
  };

  const navigateToOrganization = async (id: string) => {
    if (hasMongoObjectId(location)) {
      setPostLoginRedirect('/');
    } else {
      const nextPath = `${location.pathname}${location.search}${location.hash}`;
      setPostLoginRedirect(nextPath);
    }
    sendOrganizationSwitch(userProfile.id, id);
  };

  return (
    <div styleName="organization-switcher-dropdown-container">
      {organizations && (
        <Select
          popupMatchSelectWidth={false}
          style={{ width: 200 }}
          value={organization?.id}
          onChange={navigateToOrganization}
          loading={loading}
        >
          {organizations
            .filter((org) => org.isActive)
            .sort((compA, compB) => sortStringAscending(compA.name, compB.name))
            .map((org) => (
              <Option key={org.id} value={org.id}>
                {org.name}
              </Option>
            ))}
        </Select>
      )}
    </div>
  );
};

export default OrganizationSwitcherDropdown;
